import './yfm-cut-title.css';
export class YfmCutTitleNodeView {
    constructor(node) {
        this.node = node;
        this.dom = document.createElement('div');
        this.dom.classList.add('yfm-cut-title');
        this.dom.replaceChildren((this.contentDOM = document.createElement('div')));
        this.contentDOM.classList.add('ye-yfm-cut-title-inner');
        this.contentDOM.addEventListener('click', (e) => {
            // ignore clicking on the title content
            // you can open/close yfm-cut by clicking on the arrow icon
            e.stopPropagation();
        });
    }
    update(node) {
        if (this.node.type !== node.type)
            return false;
        this.node = node;
        return true;
    }
}
